import { faCar } from '@fortawesome/pro-regular-svg-icons/faCar';
import { faClipboardListCheck } from '@fortawesome/pro-regular-svg-icons/faClipboardListCheck';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { Col, Row, theme } from 'antd';
import { useJobSlotStartAndEndDisplayTimes } from 'pos-client/components/scheduleBoard/hooks/useJobSlotStartAndEndDisplayTimes.ts';
import { useJobStatusTextColor } from 'pos-client/components/scheduleBoard/hooks/useJobStatusTextColor.ts';
import type { ScheduleBoardJobModel } from 'pos-shared/models/schedulingSchema.ts';

import { JobSlotContentStatusIcons } from './JobSlotContentStatusIcons.tsx';
import { JobSlotDetail } from './JobSlotDetail.tsx';

interface JobSlotContentProps {
  jobData: ScheduleBoardJobModel;
  isInConflict?: boolean;
}

export const JobSlotContent = ({
  jobData,
  isInConflict,
}: JobSlotContentProps) => {
  const { token } = theme.useToken();

  const textColor = useJobStatusTextColor(jobData.state);

  const { startDisplay, endDisplay } = useJobSlotStartAndEndDisplayTimes(
    jobData.startDateDisplay,
    jobData.endDateDisplay,
    true
  );

  return (
    <Col
      style={{
        position: 'relative',
        color: textColor,
        borderColor: textColor,
        width: '100%',
      }}
    >
      <JobSlotContentStatusIcons
        state={isInConflict ? 'conflict' : jobData.state}
        slotType={jobData.slotType}
        jobData={jobData}
      />
      <Row style={{ fontSize: token.fontSizeSM, textWrap: 'wrap' }}>
        <JobSlotDetail
          detail={jobData.jobType}
          icon={faClipboardListCheck}
          dividerWidth="90%"
          fontWeight="strong"
        />
        <JobSlotDetail
          detail={`${jobData.customer?.firstName} ${jobData.customer?.lastName}`}
          icon={faUser}
        />
        {jobData.fulfilmentTo.reference && (
          <JobSlotDetail detail={jobData.fulfilmentTo.reference} icon={faCar} />
        )}
        {/* <div style={{ marginBottom: token.marginSM }}> //TODO once we have the data from BE we can replace this with the actual condition message / data
          <JobSlotDetail
            detail={t('common.errors.noInformation')} 
            icon={faClipboardUser}
            showDivider={false}
          />
        </div> */}
        <JobSlotDetail
          detailsList={[startDisplay, endDisplay]}
          icon={faClock}
          showDivider={false}
        />
      </Row>
    </Col>
  );
};
